module.exports = __webpack_public_path__ + "static/icon-cancel.36217925.png";